<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Encuestas</strong>
          </div>
          <b-form>
            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model= "fechaDesde" 
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model= "fechaHasta" 
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <app-encuesta-usuario-tipo
              label="Tipo de Encuesta"
              :labelCols="labelCols"
              :nombre="encuestaUsuarioTipoNombre"
              :lista="encuestasUsuariosTiposList"
              @validate="validate"
              @updated="encuestaUsuarioTipoActualizado">
            </app-encuesta-usuario-tipo>            
          </b-form>

          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="exportXls">Exportar XLS</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import EncuestaUsuarioTipo from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';

export default {
  name: 'RptEncuestasUsuarios',
  components: {
    appEncuestaUsuarioTipo: EncuestaUsuarioTipo,
    appMensaje: Mensaje,
  },
  mixins: [
    msjModal,
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      encuestaUsuarioTipo: null,

      encuestasUsuariosTipos: [],
      encuestasUsuariosTiposList: [],

      labelCols: 2,
    }
  },
  computed: {
    encuestaUsuarioTipoId() {
      if (this.encuestaUsuarioTipo) {
        return this.encuestaUsuarioTipo.id;
      }
      return 0;
    },
    encuestaUsuarioTipoNombre() {
      if (this.encuestaUsuarioTipo) {
        return this.encuestaUsuarioTipo.nombre;
      }
      return null;
    },
  },
  created() {
    this.getDatosAdicionales();    
  },  
  methods: {
    getDatosAdicionales() {
      this.$store.dispatch('encuestasUsuarios/getTiposList')
        .then(() => {
          this.encuestasUsuariosTipos = this.$store.getters['encuestasUsuarios/tiposList'];
          this.encuestasUsuariosTiposList = this.$store.getters['encuestasUsuarios/tiposSelectList'];
        })
        .catch(() => this.showErrorMsj('Se produjo un error al recuperar la lista de tipos de encuesta.'));
    },
    validate() {

    },
    exportXls () {
      let execute = true;

      this.noValidar = false;

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        encuestaUsuarioTipoId: this.encuestaUsuarioTipoId,
      }

      if (execute) {
        this.showSpinner();
        this.$store.dispatch('encuestasUsuarios/getRptEncuestas', params)
          .then(() => {
            let exportRpt = Boolean(false); 
            let rptEncuestas = this.$store.getters['encuestasUsuarios/rptEncuestasUsuarios'];

            if (rptEncuestas) {
              if (rptEncuestas.length != 0) {
                exportRpt = Boolean(true);
              }
            }
            if (exportRpt) {
              let title= 'Encuestas de Usuarios';
              let fileName = 'encuestas-usuarios';

              let format = [
                { titulo: 'Fecha Encuesta', nombre: 'fechaEncuesta', formato: 'fecha' },
                { titulo: 'Tipo', nombre: 'encuestaUsuarioTipo', formato: '' },
                { titulo: 'Referido', nombre: 'usuarioReferido', formato: '' },
                { titulo: 'Encuestado', nombre: 'usuario', formato: '' },
                { titulo: 'Calificación', nombre: 'calificacion', formato: '' },
                { titulo: 'Referencia', nombre: 'referencia', formato: '' },
              ];

              if (this.encuestaUsuarioTipoId != 0) {
                if (rptEncuestas.length > 0) {
                  let encuesta = rptEncuestas[0];
                  if (Array.isArray(encuesta.items)) {
                    encuesta.items.forEach(item => {
                      format.push({ titulo: item.consulta, nombre: item.consulta, formato: '' });
                    });
                  }

                  rptEncuestas.forEach(encuesta => {
                    if (Array.isArray(encuesta.items)) {
                      encuesta.items.forEach(item => {
                        if (item.tipoConsulta == 1) {
                          encuesta[item.consulta] = item.calificacion.toString();
                        } else if (item.tipoConsulta == 2) {
                          encuesta[item.consulta] = item.aprobado? 'Si' : 'No';
                        }
                      });
                    }
                  });
                }
              }

              this.exportXLS(title, fileName, rptEncuestas, format);
            } else {
              this.showModalMsj('No hay datos para exportar', null, null, 'light');
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    encuestaUsuarioTipoActualizado(encuestaUsuarioTipoNombre) {
      let encuestaUsuarioTipo = null;
      if (encuestaUsuarioTipoNombre) {
        encuestaUsuarioTipo = this.getSelected(this.encuestasUsuariosTipos, encuestaUsuarioTipoNombre);
      }

      this.encuestaUsuarioTipo = encuestaUsuarioTipo;
    }   
  },
}
</script>

<style>
</style>
